/**
 * Legacy screenshot definitions - maintained for backward compatibility
 * New content should use the main homepageContent.ts configuration
 */

import type { Screenshot } from '../types/homepage';

// Re-export the Screenshot type for backward compatibility
export type { Screenshot };

/**
 * @deprecated Use HOMEPAGE_CONTENT.screenshots from homepageContent.ts instead
 * This is maintained for backward compatibility only
 */
export const HOMEPAGE_SCREENSHOTS: Screenshot[] = [
  {
    id: 'dashboard-desktop',
    src: '/screenshots/dashboard-desktop.svg',
    alt: 'Dashboard overview showing bowling statistics and performance metrics',
    title: 'Dashboard Overview',
    description: 'Get a comprehensive view of your bowling performance with key statistics, averages, and quick navigation to detailed analytics.',
    category: 'dashboard',
    order: 1
  },
  {
    id: 'performance-chart',
    src: '/screenshots/performance-chart.svg',
    alt: 'Performance chart showing weekly bowling average trends over time',
    title: 'Performance Analytics',
    description: 'Track your weekly performance trends with interactive charts that show your improvement over time compared to league averages.',
    category: 'charts',
    order: 2
  },
  {
    id: 'comparison-view',
    src: '/screenshots/comparison-view.svg',
    alt: 'League comparison view showing player stats versus league averages',
    title: 'League Comparison',
    description: 'Compare your performance against league averages and see how you rank among other players in your league.',
    category: 'comparison',
    order: 3
  },
  {
    id: 'lane-analysis',
    src: '/screenshots/lane-analysis.svg',
    alt: 'Lane analysis showing performance breakdown by lane numbers',
    title: 'Lane Analysis',
    description: 'Discover which lanes you perform best on and optimize your game strategy with detailed lane-by-lane performance data.',
    category: 'analysis',
    order: 4
  },
  {
    id: 'mobile-interface',
    src: '/screenshots/mobile-interface.svg',
    alt: 'Mobile interface showing responsive design on smartphone',
    title: 'Mobile Experience',
    description: 'Access your bowling statistics anywhere with our fully responsive mobile interface designed for on-the-go analysis.',
    category: 'mobile',
    order: 5
  },
  {
    id: 'game-history',
    src: '/screenshots/game-history.svg',
    alt: 'Game history table showing detailed series breakdown by week',
    title: 'Game History',
    description: 'Review your complete bowling history with detailed game-by-game breakdowns, series totals, and performance notes.',
    category: 'dashboard',
    order: 6
  },
];